<template>
  <button class="tx-button" @click="handle_send_log" :style="computedStyle">
    <slot></slot>
  </button>
</template>
<script setup>
import config from '@img/config.json';
import px2vw from '../utils/px2vw';
const { support_image } = inject('GlobalStore');
const GlobalReporter = inject('GlobalReporter');

const props = defineProps({
  src: {
    type: String,
    required: true,
  },
  name: {
    type: String,
    required: false,
  },
});
const bg = computed(() => {
  let img_conf= config[props.src];
  if(img_conf){
    return `${img_conf.src}.${support_image.value}`;
  }else{
    console.error('图片配置文件中没有这个src字段', props.src)
  }
});
const computedStyle = computed(() => {
  const size = config[props.src];
  return {
    backgroundImage: `url(${bg.value})`,
    width: px2vw(size.width) + 'vw',
    height: px2vw(size.height) + 'vw',
  };
});

function handle_send_log() {
  if (props.name) {
    GlobalReporter.add({ btn_name: props.name });
  } else {
    console.error('可以为这个Button组件添加一个name字段，用来记录按钮点击日志');
  }
}
onMounted(async () => {
  // let src = config[props.src].src;
  // bg.value = `${src}.${support_image.value}`;
});
</script>
<style scoped>
.tx-button {
  background-repeat: no-repeat;
  background-size: contain;
  background-position: top;
}
</style>
